import type {
    InternalOrderCreateComponentProcess,
    InternalOrderCreateComponentProperty,
    InternalOrderCreateProductComponent
} from '@/types/domain/orders/internal'

export function normalizeProductDimension(value: unknown): number | null {
    if (value == null || value === '') return null

    const numericValue = Number(value)
    if (!Number.isFinite(numericValue)) return null

    return Math.round(numericValue)
}

export function prepareOrderProductComponentForCreate(component: InternalOrderCreateProductComponent): Record<string, unknown> {
    return {
        componentId: component.componentId,
        numberOfCopies: component.numberOfCopies ?? 1,
        orderComponentProperties: (component.orderComponentProperties ?? []).map(prepareOrderComponentPropertyForCreate),
        orderComponentProcesses: (component.orderComponentProcesses ?? []).map(prepareOrderComponentProcessForCreate)
    }
}

export function prepareOrderProductComponentsForCreate(
    components: InternalOrderCreateProductComponent[]
): Record<string, unknown>[] {
    return components.map(prepareOrderProductComponentForCreate)
}

function prepareOrderComponentPropertyForCreate(property: InternalOrderCreateComponentProperty): Record<string, unknown> {
    return {
        productProductionPropertyId: property.productProductionPropertyId,
        value: property.value ?? ''
    }
}

function prepareOrderComponentProcessForCreate(process: InternalOrderCreateComponentProcess): Record<string, unknown> {
    return {
        productionProcessId: process.productionProcessId
    }
}
